<script setup lang="ts">
import { computed, inject, Ref } from "vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { FieldStyle } from "@/builder/enums";
import { PageDesign } from "../page/PageInterface";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";

const props = defineProps(["component"]);
const store = useRenderStore();

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});
</script>

<template>
    <ValidatedInput :id="props.component.id" :value="store.gift.comments" :label="props.component.customData.label"
        accessibleLabel="Comments" name="Comments" class="rd-w-full"
        :class="{ 'form-compact-full': fieldStyle == FieldStyle.Compact }"
        :isRequired="props.component.customData.required">

        <template #input="inputProps">
            <textarea v-model="store.gift.comments" :placeholder="component.customData.placeholder"
                :aria-describedby="inputProps.describedBy" :aria-required="inputProps.required"
                :aria-invalid="inputProps.isInvalid" :id="component.id + '_Comments'" resize="none" rows="4"></textarea>
        </template>
    </ValidatedInput>
</template>